module.exports = __webpack_public_path__ + "static/media/logo-tagesspiegel.f64883f8.svg";